module.exports = __webpack_public_path__ + "static/media/rss-square.4b966f40.svg";